module.exports = __webpack_public_path__ + "static/media/vf_wwallet_core.747dcda9.svg";